import React, { Component } from "react";
import { Link } from "react-router-dom";

class Breadcrumb extends Component{
    render(){
        const { title , parent} = this.props;
        return(
            <React.Fragment>
                <div className="rn-page-title-area pt--10 pb--10 bg_image bg_image--2" data-black-overlay="4">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div style={{marginBottom: 100}} className="breadcrumb-inner pt--100">
                                    <h2 className="title title theme-gradient"><em>{title}</em></h2>
                                    <ul className="page-list">
                                        <li className="breadcrumb-item "><Link to={`${process.env.PUBLIC_URL}`}>Home</Link></li>
                                        {parent? <li className="breadcrumb-item ">{parent}</li>:''}
                                        <li className="breadcrumb-item active">{title}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Breadcrumb;
